import React,{ useState} from "react";
import { styled } from "@mui/material/styles";
import Table from "@mui/material/Table";
import TableBody from "@mui/material/TableBody";
import TableCell, { tableCellClasses } from "@mui/material/TableCell";
import TableContainer from "@mui/material/TableContainer";
import TableHead from "@mui/material/TableHead";
import TableRow from "@mui/material/TableRow";
import Paper from "@mui/material/Paper";
import TableSortLabel from '@mui/material/TableSortLabel';
import "../../../styles/pageStyles/userListing/userListing.css"
import {  useNavigate } from "react-router-dom";
import TablePagination from '@mui/material/TablePagination';
import Skeleton from "@mui/material/Skeleton";

const StyledTableCell = styled(TableCell)(({ theme }) => ({
    [`&.${tableCellClasses.head}`]: {
      backgroundColor: "#E9E9E9",
      color: "black",
      fontSize: "14px",
      fontWeight: 600,
      fontFamily: "proxima-regular !important",
      padding:'8px',
    },
    [`&.${tableCellClasses.body}`]: {
      fontSize: '14px',
      fontFamily: "proxima-regular !important",
      padding:'8px',
    },
  }));
  
  const StyledTableRow = styled(TableRow)(({ theme }) => ({
    "&:nth-of-type(even)": {
      backgroundColor: "#E9E9E9",
    },
    // hide last border
    "&:last-child td, &:last-child th": {
      border: 0,
    },
  }));

const headCells = [
    { id: 'username', numeric: false, disablePadding: false, label: 'Username ' },
    { id: 'email', numeric: false, disablePadding: false, label: 'Email ID ' },
    { id: 'first_name', numeric: false, disablePadding: false, label: 'First Name ' },
    { id: 'last_name', numeric: false, disablePadding: false, label: 'Last Name' },
    { id: 'role', numeric: false, disablePadding: false, label: 'Role' },
    { id: 'active', numeric: false, disablePadding: false, label: 'Active' },
    { id: 'last_login', numeric: false, disablePadding: false, label: 'Last Login' },
];

const UserListingTable = ({props}) => {
    const {tableData,setTableData,setUserList,order, setOrder,orderBy, setOrderBy,userDataToMap,userNotFound,tableLoader}=props;
    const [page, setPage] = useState(0);
    const [rowsPerPage, setRowsPerPage] =useState(8);
    const navigate=useNavigate ()

    const handleRequestSort = (event, property) => {
        const isAsc = orderBy === property && order === 'asc';
        setOrder(isAsc ? 'desc' : 'asc');
        setOrderBy(property);
    };

    const createSortHandler = (property) => (event) => {
        if(property!=='role' && property!=='active'){
            handleRequestSort(event, property);
        }
    };

    const filterCaseInsensitive = (filter, row) => {
        const id = filter.pivotId || filter.id;
        if (row[id] !== null) {
            return (
                row[id] !== undefined ?
                    String(row[id].toString().toLowerCase())
                        .includes(filter.value.toString().toLowerCase())
                    :
                    true
            );
        }
    }

    function tableSort(array, comparator) {
        const stabilizedThis = array.map((el, index) => [el, index]);
        stabilizedThis.sort((a, b) => {
            const order = comparator(a[0], b[0]);
            if (order !== 0) return order;
            return a[1] - b[1];
        });
        return stabilizedThis.map((el) => el[0]);
    }

    function descendingComparator(a, b, orderBy) {
        if (b[orderBy] && b[orderBy].toLowerCase() > a[orderBy] && a[orderBy].toLowerCase()) {
            return 1;
        }
        if (b[orderBy] && b[orderBy].toLowerCase() < a[orderBy] && a[orderBy].toLowerCase()) {
            return -1;
        }
        else if (b[orderBy] && a[orderBy] && a[orderBy].toLowerCase() === b[orderBy] && b[orderBy].toLowerCase()) {
            return 0;
        }
    }

    function getComparator(order, orderBy) {
        return order === 'desc'
            ? (a, b) => descendingComparator(a, b, orderBy)
            : (a, b) => -descendingComparator(a, b, orderBy);
    }

    const handleChangePage = (event, newPage) => {
        setPage(newPage);
    };

    const handleChangeRowsPerPage = (event) => {
        setRowsPerPage(parseInt(event.target.value, 10));
        setPage(0);
    };
    
    function handleOpenUser(userData) {
        // setPostType('edit')
        navigate('/user',{state: { userData: userData, postType: 'edit' }});
    }

    return (
   <>
    {tableLoader? 
    <TableContainer component={Paper} sx={{border:'1px solid black',marginTop:'1em'}}>
      <Table sx={{ minWidth: 700 }} aria-label="customized table">
        <TableHead>
          <TableRow>
            <TableCell>
               <Skeleton variant="rectangular" width='100%' height='50px' animation="wave"/>
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
        {new Array(8).fill(0).map(() => {
          return (
            <TableRow>
              <TableCell colSpan={1}>
                  <Skeleton variant="rectangular" width="100%" height='40px' animation="wave" />          
              </TableCell>
            </TableRow>
          )
        })}
        </TableBody>
      </Table>
    </TableContainer>
    :(
    <TableContainer component={Paper} sx={{border:'1px solid black',marginTop:'1em'}}>
      <Table sx={{ minWidth: 700 }} 
             aria-label="customized table" 
             defaultFilterMethod={filterCaseInsensitive}
        >
        <TableHead>
          <TableRow>
            {headCells.map((headCell) => (
                <StyledTableCell key={headCell.id}
                    align="left"
                    padding="default"
                    sortDirection={orderBy === (headCell.id && (headCell.id !=='role'|| headCell.id !=='active'  )) ? order : false}
                >
                    <TableSortLabel
                            active={orderBy === (headCell.id && (headCell.id !=='role'|| headCell.id !=='active'  ))}
                            direction={orderBy === headCell.id && (headCell.id !=='role'|| headCell.id !=='active'  )  ? order : 'asc'}
                            hideSortIcon={(headCell.id ==='role'|| headCell.id ==='active'  )?true:false}
                            onClick={createSortHandler(headCell.id)}
                            >
                            {headCell.label}
                            {orderBy === headCell.id ? (
                                <span
                                 className='visually-hidden'
                                >
                                    {order === 'desc' ? 'sorted descending' : 'sorted ascending'}
                                </span>
                            ) : null}
                    </TableSortLabel>
                </StyledTableCell>
            ))}
          </TableRow>
        </TableHead>
       { !userNotFound ? <TableBody>
         {tableSort(userDataToMap, getComparator(order, orderBy))
          .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
          .map((row) => {
            const options = { weekday: 'long', year: 'numeric', month: 'full', day: 'numeric' };
            options.timeZone = 'UTC';
            options.timeZoneName = 'short';
            return (
            <StyledTableRow >
              <StyledTableCell 
                component="tr" 
                scope="row" 
                align="left" 
                className="individual-user-row"
                onClick={() => {handleOpenUser(row) }}>
                {row.username}
              </StyledTableCell>
              <StyledTableCell align="left">{row.email}</StyledTableCell>
              <StyledTableCell align="left">{row.first_name}</StyledTableCell>
              <StyledTableCell align="left">{row.last_name}</StyledTableCell>
              <StyledTableCell align="left" >
                <div>
                    {row.groups.map(
                        (t, i) => <div>{t.name}{row.groups.length - 1 === i ? '' : ','} </div>
                        )
                    }
                </div>
              </StyledTableCell>
              <StyledTableCell align="left">{row.is_active ? 'Yes' : 'No'}</StyledTableCell>
              <StyledTableCell align="left">{row.last_login ? new Date(row.last_login).toLocaleString('en-US', 'options', { hour12: false }) : 'NA'}</StyledTableCell>
            </StyledTableRow>
            )})} 
        </TableBody>
        :
        <TableBody>
            <TableRow>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell><span style={{ color: 'black',fontFamily:'proxima-regular',fontSize:'14px' }}>User Not Found</span></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
                <TableCell></TableCell>
            </TableRow>
        </TableBody>
        }
      </Table>
    </TableContainer>
    )}
    <div className="user-listing-pagination-container">
            <>
            {!tableLoader && !userNotFound &&
                <TablePagination
                        className="user-listing-pagination"
                        rowsPerPageOptions={[]}
                        component="div"
                        count={userDataToMap?.length}
                        rowsPerPage={rowsPerPage}
                        page={page}
                        onPageChange={handleChangePage}
                        onChangeRowsPerPage={handleChangeRowsPerPage}
                        slots={{
                            spacer: () => null,  // Set spacer to null to remove it entirely
                          }}
                        sx={{
                            '.MuiTablePagination-displayedRows': {
                              transform: 'translate(160px, 0px)',
                              width:'120px',
                              visibility:'unset',
                              display: 'flex', // Use flex to align the items properly
                              justifyContent: 'center', // Center text horizontally
                              alignItems: 'center', // Center text vertically
                              flex: 'grow', // Allow this section to grow or shrink
                            },
                            '.MuiTablePagination-spacer': {
                                // display: 'none', 
                                backgroundColor:'black' // Hide the spacer entirely
                                },
                          }}
                          slotProps={{
                            spacer:{
                                display:'none',
                                backgrounColor:'black'
                            }
                          }}
                /> 
              }
            </> 
        </div>
   </>
  )
}

export default UserListingTable